export default "__VITE_ASSET__DxqG4l6r__"